// 3. 基础配置数据(右侧选择框内容)
// 3.1 医学类别声明, 结合test.json属进行说明
//  1.categoryInfo属于test.json中所有nodes的category信息的集合
//  2.test.json的term属性, 是具体的疾病名称, 是category的子集, 且作为nodes的节点名称, 理论上是唯一字段, 但实际上不是如Diabetes Mellitus有一个小写的同名
//  3.test.json的id属性, 是唯一的, 搜索term会出现相关id和id的target的id, 但只出现一层, 即只出现target的id, 不会出现target的target的id
//  4.test.json的degree属性, 是节点的连接数, 代表该节点有多少连接(多少条线)
//  5.test.json的size属性, 可以控制节点大小, 也作为节点的阈值
import {reactive} from "vue";

export const categoryInfo = reactive([

    // 按照shapeMap的顺序排列
    // CUI相关类别 (cube形状)
    // {"db_category": "ACTI", "shape": "cube", "color": "#e879f9"},
    // {"db_category": "CHEM", "shape": "cube", "color": "#d946ef"},
    // {"db_category": "DISO", "shape": "cube", "color": "#c026d3"},
    // {"db_category": "PHEN", "shape": "cube", "color": "#a21caf"},
    // {"db_category": "PHYS", "shape": "cube", "color": "#86198f"},
    // {"db_category": "PROC", "shape": "cube", "color": "#701a75"},
    // {"db_category": "Other CUI", "shape": "cube", "color": "#4a044e"},

    // Phenotyoe
    // {"db_category": "RXNORM", "shape": "cube", "color": "#187A1A"},
    // {"db_category": "PheCode", "shape": "cube", "color": "#441DF0"},
    // {"db_category": "CCS", "shape": "cube", "color": "#D74D00"},
    // {"db_category": "LOINC", "shape": "cube", "color": "#002FA7"},
    // {"db_category": "Other lab", "shape": "cube", "color": "#FFCF14"},
    // {"db_category": "ShortName", "shape": "cube", "color": "#00C6F2"},

    // {"db_category": "Disease Codified", "shape": "cube", "color": "#a6cee3"},
    // {"db_category": "Disease NLP", "shape": "cube", "color": "#1f78b4"},
    // {"db_category": "Drug Codified", "shape": "cube", "color": "#b2df8a"},
    // {"db_category": "Drug NLP", "shape": "cube", "color": "#33a02c"},
    // {"db_category": "Lab Codified", "shape": "cube", "color": "#fb9a99"},
    // {"db_category": "Lab NLP", "shape": "cube", "color": "#e31a1c"},
    // {"db_category": "Procedure Codified", "shape": "cube", "color": "#cab2d6"},
    // {"db_category": "Procedure NLP", "shape": "cube", "color": "#6a3d9a"},
    // {"db_category": "Other NLP", "shape": "cube", "color": "#b15928"},
    //
    //
    // // Genotype
    // {"db_category": "environmental information processing", "shape": "sphere", "color": "#2DAACC"},
    // {"db_category": "genetic information processing", "shape": "sphere", "color": "#A822A1"},
    // {"db_category": "human diseases", "shape": "sphere", "color": "#187A1A"},
    // {"db_category": "metabolism", "shape": "sphere", "color": "#652C97"},
    // {"db_category": "organismal systems", "shape": "sphere", "color": "#FFCF14"},
    // {"db_category": "signaling and cellular processes", "shape": "sphere", "color": "#E09CFF"},
    // {"db_category": "intergenic", "shape": "sphere", "color": "#002FA7"},
    // {"db_category": "non coding RNA", "shape": "sphere", "color": "#F20C51"},
    // {"db_category": "other gene", "shape": "sphere", "color": "#D74D00"},
    //
    // {"db_category": "other", "shape": "sphere", "color": "white"},

    {"db_category": "Disease Codified", "shape": "cube", "color": "#002FA7"},
    {"db_category": "Disease NLP", "shape": "cube", "color": "#1f78b4"},
    {"db_category": "Drug Codified", "shape": "cube", "color": "#b2df8a"},
    {"db_category": "Drug NLP", "shape": "cube", "color": "#33a02c"},
    {"db_category": "Lab Codified", "shape": "cube", "color": "#D74D00"},
    {"db_category": "Lab NLP", "shape": "cube", "color": "#e31a1c"},
    {"db_category": "Procedure Codified", "shape": "cube", "color": "#A822A1"},
    {"db_category": "Procedure NLP", "shape": "cube", "color": "#652C97"},
    {"db_category": "Other NLP", "shape": "cube", "color": "#fb9a99"},


    // Genotype
    {"db_category": "environmental information processing", "shape": "sphere", "color": "#D74D00"},
    {"db_category": "genetic information processing", "shape": "sphere", "color": "#A822A1"},
    {"db_category": "human diseases", "shape": "sphere", "color": "#187A1A"},
    {"db_category": "metabolism", "shape": "sphere", "color": "#F20C51"},
    {"db_category": "organismal systems", "shape": "sphere", "color": "#FFCF14"},
    {"db_category": "signaling and cellular processes", "shape": "sphere", "color": "#002FA7"},
    {"db_category": "intergenic", "shape": "sphere", "color": "#780058"},
    {"db_category": "non coding RNA", "shape": "sphere", "color": "#998297"},
    {"db_category": "other gene", "shape": "sphere", "color": "#5F7099"},

    {"db_category": "other", "shape": "sphere", "color": "white"}
]);

export const nodeShapeInfo = reactive([
    {"db_category": "Phenotype", "shape": "cube", "color": "#2272ec"},
    {"db_category": "Pheno's Parent", "shape": "cone", "color": "#2272ec"},
    {"db_category": "Pathway", "shape": "sphere", "color": "#2272ec"},
    {"db_category": "Gene", "shape": "icosahedron", "color": "#2272ec"},
    {"db_category": "SNP", "shape": "dodecahedron", "color": "#2272ec"},
]);
